// A programme that ends at midnight reports end minute 0, which as a "To" time
// would come before its start and leave nothing to draw.
export function programEndClock(prog) {
  const end = prog.endMinute <= prog.startMinute ? 1439 : prog.endMinute;
  const hh = String(Math.floor(end / 60)).padStart(2, "0");
  const mm = String(end % 60).padStart(2, "0");
  return `${hh}:${mm}`;
}
